// extracted by mini-css-extract-plugin
export default {"premium_component":"Premium_premium_component__p4vhJ","sec_name":"Premium_sec_name__2SHmM"};